import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelButton from '../atoms/CancelButton';
import ConfirmTextButton from '../atoms/ConfirmTextButton';

const styles = {
  textRed: {
    color: 'red'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  },
  textBlack: {
    color: 'black'
  }
};

const enhance = compose();

const Main = enhance(
  ({
    openConfirm,
    updateOpenConfirm,
    cancelAction,
    confirmAction,
    validateData,
    classes
  }) => {
    console.log('validateData', validateData.code);
    let message = '';
    let message2 = '';
    if (validateData.code === 200) {
      message2 = `${validateData.numberShop}件をDBにインポートしましょうか？`;
    } else if (validateData.code === 400) {
      // eslint-disable-next-line prefer-destructuring
      message = validateData.message;
      message2 = `エラーのデータを除き、${
        validateData.numberShop
      }件をDBにインポートしましょうか？`;
    } else {
      message = '';
    }
    return (
      <Dialog
        open={openConfirm}
        onClose={() => {
          updateOpenConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={[classes.textRed, classes.breakLine]}
          >
            {message}
            <div className={classes.textBlack}>{message2}</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <ConfirmTextButton onClickAction={confirmAction} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
